import { APIEnv } from './types/env.types';
import { Env } from './env';

export const getIframeParentUrl = () => {
    return window.location !== window.parent.location ? document.referrer : document.location.href;
};

export const getDomainFromFullUrl = (url: string): string | null => {
    return url.split(/\/+/)[1] || null;
};

export namespace CompanyCDN {
    const TEST_ENV_PATH_PREFIX = '/test';
    const PROD_ENV_PATH_PREFIX = '/prod';

    export const url = (filePath: string, autoEnv = false) => {
        const delimiter = filePath.startsWith('/') ? '' : '/';
        if (!autoEnv) {
            return process.env.COMPANY_CDN_DOMAIN + delimiter + filePath;
        }
        const envPrefix =
            Env.getAPIEnv() === APIEnv.Test ? TEST_ENV_PATH_PREFIX : PROD_ENV_PATH_PREFIX;
        return process.env.COMPANY_CDN_DOMAIN + envPrefix + delimiter + filePath;
    };
}
